import { jurisdictionModelData } from './models/JurisdictionsModel'
import { AdminJurisdictionService } from './api/AdminJurisdictionService'

const JurisdictionModule = {
  namespaced: true,
  state: jurisdictionModelData(),
  getters: {
    fetchJurisdictionList: state => state.jurisdictionList,
    fetchPaginatedJurisdictionList: state => state.paginatedJurisdictionList,
    fetchQueryParams: state => state.queryParams,
    fetchEditDialog: state => state.editDialog,
    fetchFIPSList: state => state.FIPSList
  },
  mutations: {
    setJurisdictionList (state, data) {
      state.jurisdictionList = data.list
    },
    setPaginatedJurisdictionList (state, data) {
      state.paginatedJurisdictionList = data.list
    },
    setEditDialog (state, data) {
      state.editDialog = data
    },
    addQueryParams (state, queryParams) {
      state.queryParams = queryParams
    },
    setFIPSList (state, data) {
      state.FIPSList = data.list
    }
  },
  actions: {
    /**
     * Get jurisdiction list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getJurisdictionList ({ commit }, { resolve, reject, fetchOnlyPublished }) {
      try {
        const response = await AdminJurisdictionService.fetchJurisdictionList(fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getJurisdictionByStateAndCounty ({ commit }, { resolve, reject, countryId, stateId, countyId, fetchOnlyPublished }) {
      try {
        const response = await AdminJurisdictionService.fetchJurisdictionByStateAndCounty(countryId, stateId, countyId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get jurisdiction list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getPaginatedJurisdictionList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminJurisdictionService.fetchPaginatedJurisdictionList(queryParams)
        const { success, data } = response.data
        if (success) {
          commit('setPaginatedJurisdictionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setPaginatedJurisdictionList', {
            list: data.list
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get FIPS list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getFIPSList ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminJurisdictionService.fetchFIPSList()
        const { success, data } = response.data
        if (success) {
          commit('setFIPSList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getFilteredJurisdictionList ({ commit }, { resolve, reject, countryId, stateId, countyId, fetchOnlyPublished }) {
      try {
        const response = await AdminJurisdictionService.fetchFilteredJurisdictionList(countryId, stateId, countyId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          commit('setJurisdictionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addJurisdictionItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminJurisdictionService.addJurisdictionItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getPaginatedJurisdictionList', { resolve, reject })
          dispatch('getJurisdictionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editJurisdictionItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminJurisdictionService.editJurisdictionItem(editedData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getJurisdictiongetMapPostalCode ({ dispatch }, { resolve, reject, id = '' }) {
      try {
        const response = await AdminJurisdictionService.fetchJurisdictionPostalCode(id)
        const { success, data } = response.data
        if (success) {
          dispatch('getJurisdictionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getJurisdictionDetailsById ({ dispatch }, { resolve, reject, idToGetInfo }) {
      try {
        const response = await AdminJurisdictionService.getJurisdictionDetailsById(idToGetInfo)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async textJurisdictionSearch ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await AdminJurisdictionService.fetchTextJurisdictionSearch(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateJuridictionDeleteItem ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await AdminJurisdictionService.validateDeleteJuridictionItem(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteJuridictionItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminJurisdictionService.deleteJuridictionItem(formData)
        const { success, data } = response.data
        if (success === true) {
          dispatch('getPaginatedJurisdictionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default JurisdictionModule
